import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { 
  initErrorTracking, 
  withProfiler, 
  getErrorBoundary 
} from '@/app/utils/errorTracking';
import App from './app/App';

import './styles/index.css';

// Initialize error tracking
initErrorTracking();

// Wrap App with profiler for performance monitoring
const ProfiledApp = withProfiler(App);

// Get error boundary component
const ErrorBoundary = getErrorBoundary();

// Create AppWithAuth component
function AppWithAuth() {
  return (
    <ProfiledApp />
  );
}

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <ErrorBoundary
      fallback={({ error }) => (
        <div style={{ padding: '2rem', textAlign: 'center' }}>
          <h1>Application Error</h1>
          <p>Sorry, something went wrong.</p>
          <pre style={{ textAlign: 'left', background: '#f5f5f5', padding: '1rem' }}>
            {error.message}
          </pre>
        </div>
      )}
      showDialog
    >
      <AppWithAuth />
    </ErrorBoundary>
  </StrictMode>
);
